import personalStatementAnomalies from './posts/7-anomaliy-v-bankovskoy-vypiske-fizicheskogo-lica';
import chtoMozhnoPonyatPoBankovskoyVypiskeZa10Minut from './posts/chto-mozhno-ponyat-po-bankovskoy-vypiske-za-10-minut';
import kakNachatPervuyuProverkuVFinradar from './posts/kak-nachat-pervuyu-proverku-v-finradar';
import companyStatementAnomalies from './posts/7-anomaliy-v-bankovskoy-vypiske-yuridicheskogo-lica';
// Draft article. Keep it out of public indexes, routes, sitemap and prerender until publication.
// import kakiePlatezhiProveritNaOsparivanie from './posts/kakie-platezhi-dolzhnika-proverit-na-osparivanie';

export { BLOG_IMAGES } from './blogImages';

export const BLOG_BASE_URL = 'https://finradar.brpadvice.ru';

export const blogPosts = [
    personalStatementAnomalies,
    companyStatementAnomalies,
    // kakiePlatezhiProveritNaOsparivanie,
    chtoMozhnoPonyatPoBankovskoyVypiskeZa10Minut,
    kakNachatPervuyuProverkuVFinradar,
];

export const blogPostBySlug = blogPosts.reduce((acc, post) => {
    acc[post.slug] = post;
    return acc;
}, {});

export function getBlogPostUrl(post) {
    return `${BLOG_BASE_URL}/blog/${post.slug}/`;
}

export function getBlogPostStructuredData(post) {
    const canonicalUrl = getBlogPostUrl(post);
    const faqBlock = post.content.find((block) => block.type === 'faq');

    return {
        '@context': 'https://schema.org',
        '@graph': [
            {
                '@type': 'BlogPosting',
                '@id': `${canonicalUrl}#article`,
                headline: post.title,
                description: post.description,
                datePublished: post.datePublished,
                dateModified: post.dateModified || post.datePublished,
                inLanguage: 'ru-RU',
                url: canonicalUrl,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': canonicalUrl,
                },
                image: {
                    '@type': 'ImageObject',
                    url: `${BLOG_BASE_URL}${post.heroImage.src}`,
                },
                author: {
                    '@type': 'Organization',
                    name: 'ФинРадар',
                    url: `${BLOG_BASE_URL}/`,
                },
                publisher: {
                    '@type': 'Organization',
                    name: 'ФинРадар',
                    url: `${BLOG_BASE_URL}/`,
                    logo: {
                        '@type': 'ImageObject',
                        url: `${BLOG_BASE_URL}/favicon-192x192.png`,
                    },
                },
                articleSection: post.articleSection || post.category,
                keywords: post.keywords,
            },
            {
                '@type': 'BreadcrumbList',
                '@id': `${canonicalUrl}#breadcrumbs`,
                itemListElement: [
                    {
                        '@type': 'ListItem',
                        position: 1,
                        name: 'ФинРадар',
                        item: `${BLOG_BASE_URL}/`,
                    },
                    {
                        '@type': 'ListItem',
                        position: 2,
                        name: 'Блог',
                        item: `${BLOG_BASE_URL}/blog/`,
                    },
                    {
                        '@type': 'ListItem',
                        position: 3,
                        name: post.title,
                        item: canonicalUrl,
                    },
                ],
            },
            ...(faqBlock ? [{
                '@type': 'FAQPage',
                '@id': `${canonicalUrl}#faq`,
                mainEntity: faqBlock.items.map((item) => ({
                    '@type': 'Question',
                    name: item.question,
                    acceptedAnswer: {
                        '@type': 'Answer',
                        text: item.answer,
                    },
                })),
            }] : []),
        ],
    };
}
